import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

// DESIGN-SYSTEM SS5.1 — heights/variants defined once, referenced
// everywhere. Only the variants this build actually uses are wired.
const variants = {
  primary: 'bg-action-primary text-text-inverse hover:bg-action-primary-hover',
  secondary: 'bg-transparent text-text-primary border border-action-secondary-border hover:bg-surface-page',
  destructive: 'bg-action-destructive text-text-inverse hover:opacity-90',
} as const;

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof variants;
};

export function Button({ variant = 'primary', className, disabled, ...props }: Props) {
  return (
    <button
      className={cn(
        'inline-flex h-10 min-h-11 items-center justify-center rounded-md px-4 text-sm font-medium transition-colors disabled:opacity-40',
        variants[variant],
        className,
      )}
      disabled={disabled}
      aria-disabled={disabled}
      {...props}
    />
  );
}
